module.exports = __webpack_public_path__ + "img/cs-baseSucc-6.913a3061.jpg";